export default __webpack_public_path__ + "static/media/ic_times.42cfce9f.svg";